module.exports = __webpack_public_path__ + "static/media/Ryan McCormack.28e54139.png";